import { AlertCircle } from "lucide-react";

const WarningBanner = () => {
  return (
    <div className="sticky top-0 z-50 bg-warning border-b border-warning-foreground/20">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-center gap-2 text-sm font-medium text-warning-foreground">
          <AlertCircle className="h-4 w-4 flex-shrink-0" />
          <p className="text-center">
            Serviciu PRIVAT de asistență și intermediere. Nu suntem afiliați cu ANCPI, ONRC sau alte instituții publice.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WarningBanner;
